import { createContext } from 'react';

export interface FileUploadContextValue {
  openDialog: () => void;
}

export const FileUploadContext = createContext<FileUploadContextValue>({
  openDialog: () => console.error('FileUploadContexProvider not found'),
});
